var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyDamage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,15.3C24.2,5.1,28.9,0,28.9,0S13.5,7.4,8.9,27.3C7,24.5,5.4,23,5.5,23.5C7.6,28.9,3,31.2,3,36.9c0.1,5.6,9.8,12,9.8,12c0,0,0,0,0,0c0.4,0.3,0.8,0.5,1.2,0.8c-0.4-0.4-0.7-0.9-1-1.3c-1.1-1.5-1.8-3.1-1.8-4.6c0-3,1.3-5.1,2.2-7.2c0.8-1.8,1.3-3.7,0.3-6.1c-0.2-0.4,0.9,0.5,2.2,2.2c2.7-7.3,5.3-13.6,5.3-13.6s0.1,9.9,3.4,16.2c3.1,5.9,3,9,3,9c5.7-5.5,7.6-14.2,7.6-14.2c2.1,1.8,3.3,4.2,3.9,6.5c1.4,4.9-1.5,9.9-1.6,10.4c0,0.2-0.1,0.4-0.1,0.6c-0.2,0.9-0.6,1.7-1.1,2.4c0.5-0.3,1-0.7,1.5-1.1c0,0,0,0,0,0c0,0,8.9-6.4,9-12c0.1-5.6-4.6-8-2.5-13.3c0.2-0.5-1.2,0.8-2.8,3.2c-1.6-5-2.7-9-8.1-13.8c0,0,1,10.9-4.8,18.7C28.8,31.7,30.8,25.5,27.5,15.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyDamage);
export default __webpack_public_path__ + "static/media/property-damage.887debc0d025abea10cdb0c0277a3135.svg";
export { ForwardRef as ReactComponent };